/**
 * DecisionsList Component
 * Displays key decisions extracted from project documents.
 */

import React from 'react';
import { Lightbulb } from 'lucide-react';
import type { KeyDecision } from '@/services/projectAnalysisApi';
import { InsightCard } from './InsightCard';

interface DecisionsListProps {
  decisions: KeyDecision[];
}

export const DecisionsList: React.FC<DecisionsListProps> = ({ decisions }) => {
  if (decisions.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <Lightbulb className="w-12 h-12 mx-auto mb-3 text-slate-300" />
        <p>No key decisions found in your documents.</p>
        <p className="text-sm mt-1">Add ADRs or architecture documents to track decisions.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {decisions.map((decision, index) => (
        <InsightCard
          key={index}
          type="decision"
          title={decision.decision}
          source={decision.source}
          status={decision.status}
          impact={decision.impact}
        />
      ))}
    </div>
  );
};

export default DecisionsList;
